var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#5F99FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58329 1.16663C3.59175 1.16663 1.16663 3.59175 1.16663 6.58329V17.4166C1.16663 20.4082 3.59175 22.8333 6.58329 22.8333H17.4166C20.4082 22.8333 22.8333 20.4082 22.8333 17.4166V6.58329C22.8333 3.59175 20.4082 1.16663 17.4166 1.16663H6.58329ZM13.457 7.08803C12.8609 5.88026 11.1386 5.88026 10.5426 7.08803L9.68845 8.81868L7.77856 9.0962C6.4457 9.28988 5.9135 10.9278 6.87796 11.868L8.25997 13.2151L7.93372 15.1172C7.70604 16.4447 9.09937 17.457 10.2915 16.8303L11.9998 15.9322L13.708 16.8303C14.9002 17.457 16.2935 16.4447 16.0658 15.1172L15.7396 13.2151L17.1216 11.868C18.086 10.9278 17.5538 9.28988 16.221 9.0962L14.3111 8.81868L13.457 7.08803Z",
    fill: "#5F99FF",
    stroke: "black",
    strokeOpacity: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.7df61fae.svg";
export { ForwardRef as ReactComponent };